import { Agent, MerchantStructure } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { SelectedAgent } from '@/components/widgets/AgentDetailActions/components/CloneAgent/components/Agents/types/SelectedAgent';

import { ICON_NAMES } from '../../../../../../config/config';
import { ActionsOption } from '../../../../../shared/components/MoreActionsMenu/types/ActionsOption';
import { Text } from '../../../../../shared/components/Text';
import { useDialog } from '../../../../../shared/hooks/useDialog';
import { AgentDetailDialog } from '../../../../../widgets/AgentDetailActions/components/AgentDetailDialog';
import { AgentDetailAction } from '../../../../../widgets/AgentDetailActions/types/AgentDetailAction';
import { StructureCard } from './StructureCard';

interface AgentCardProps {
  agent: Agent | SelectedAgent;
  merchantStructure?: MerchantStructure;
  isOutlined?: boolean;
  isMobile?: boolean;
  redirectPath?: string;
  editModeAllowed?: boolean;
}

export const AgentCard = ({
  agent,
  merchantStructure,
  isOutlined,
  redirectPath,
  isMobile,
  editModeAllowed = false,
}: AgentCardProps) => {
  const [currentAction, setCurrentAction] = useState<AgentDetailAction | undefined>();
  const { opened, setOpened, toggleDialog } = useDialog();

  const toggleActionDialog = (actionType: AgentDetailAction) => {
    setCurrentAction(actionType);
    toggleDialog();
  };

  const actions: ActionsOption[] = [
    {
      display: <Text tId={'CLONE_AGENT_MENU'} />,
      iconName: 'content_copy',
      onClick: () => toggleActionDialog(AgentDetailAction.CLONE_AGENT),
    },
    {
      display: <Text tId={'UPDATE_AGENT_MENU'} />,
      iconName: 'content_copy',
      onClick: () => toggleActionDialog(AgentDetailAction.UPDATE_AGENT),
    },
    {
      display: <Text tId={'CHANGE_TO_ANOTHER_CHANNEL'} />,
      iconName: 'swap_horiz',
      onClick: () => toggleActionDialog(AgentDetailAction.CHANGE_TO_ANOTHER_CHANNEL),
    },
    {
      display: <Text tId={'BLOCK_ALL_USERS'} />,
      iconName: 'lock',
      onClick: () => console.log('hello'),
      disabled: true, //TODO
    },
  ];

  if (isAgent(agent)) {
    return (
      <>
        <StructureCard
          id={agent.id}
          type={'agent'}
          isSelected={isOutlined}
          redirectPath={redirectPath}
          name={agent.name}
          username={agent.username}
          iconName={ICON_NAMES.AGENT}
          copyToClipboard={{ value: agent.id, textId: 'COPY_AGENT_ID' }}
          badgeColor={agent.isBlocked ? 'error' : 'success'}
          isMobile={isMobile ?? false}
          actions={actions}
          editModeAllowed={editModeAllowed}
        />
        {currentAction && (
          <AgentDetailDialog
            currentAction={currentAction}
            agent={agent}
            merchantStructure={merchantStructure}
            opened={opened}
            setOpened={setOpened}
            toggleDialog={toggleActionDialog}
          />
        )}
      </>
    );
  }

  return (
    <StructureCard
      id={agent.agentId}
      type={'agent'}
      isSelected={isOutlined}
      redirectPath={redirectPath}
      name={agent.agentName}
      username={agent.agentEmail}
      iconName={ICON_NAMES.AGENT}
      copyToClipboard={{ value: agent.agentId, textId: 'COPY_AGENT_ID' }}
      isMobile={isMobile ?? false}
      actions={actions}
      editModeAllowed={editModeAllowed}
    />
  );
};

const isAgent = (agent: Agent | SelectedAgent): agent is Agent => (agent as Agent).id !== undefined;
